
import { computed, defineComponent } from "vue";

import missingAvatarImage from "../../assets/missing-avatar.png";
import { CAvatar } from "../../vuetify-components";
import CImage from "../CImage/CImage.vue";

export default defineComponent({
  components: { CAvatar, CImage },
  mixins: [CAvatar],
  props: {
    // From the base VAvatar component
    width: {
      type: [String, Number],
      default: undefined,
    },
    height: {
      type: [String, Number],
      default: undefined,
    },

    src: {
      type: String,
      required: true,
    },
    errorSrc: {
      type: String,
      default: missingAvatarImage,
    },
    size: {
      type: [String, Number],
      required: true,
    },
  },
  setup(props, _context) {
    /**
     * Filter out incompatible props intended for c-image. Since this component extends VAvatar
     * it is expected that all unexpected props are supposed to apply to c-image.
     */
    const avatarProps = computed(() => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { src, errorSrc, ...$props } = props;

      return $props;
    });

    return { avatarProps };
  },
});
